<p-fieldset>
    <p-header class="article-title">
        <span class="article-title">{{ 'UNIFIED-SERVICE-REPORT' | translate }}</span>
        <div class="header-buttons">
            <button class="fab-button primary" (click)="exportExcel()" [disabled]="loading"
                pTooltip="Exportar relatório para Excel" tooltipPosition="left">
                <i class="pi pi-file-excel"></i>
            </button>
        </div>
    </p-header>
    <form class="filters" [formGroup]="filterForm" (ngSubmit)="searchData()">
        <div class="filter-row">
            <div class="form-control">
                <label for="customerName">{{ 'CUSTOMER' | translate }}</label>
                <input pInputText type="text" formControlName="customerName" name="customerName">
            </div>
            <div class="form-control">
                <label for="codRegistration">{{ 'BOX-REF' | translate }}</label>
                <input pInputText type="text" formControlName="codRegistration" name="codRegistration" maxlength="12">
            </div>
            
            <div class="form-control">
                <label for="recurringServiceType">{{ 'RECURRING-SERVICE-TYPE' | translate }}</label>
                <p-multiSelect 
                    formControlName="recurringServiceType" 
                    name="recurringServiceType" 
                    appendTo="body"
                    [options]="recurringServiceTypeOptions"
                    optionLabel="label"
                    optionValue="value"
                    [showToggleAll]="true"
                    defaultLabel="Selecione os tipos"
                    display="chip">
                </p-multiSelect>
            </div>
            <div class="form-control">
                <label for="serviceStatus">{{ 'SERVICE-STATUS' | translate }}</label>
                <p-dropdown 
                    formControlName="serviceStatus" 
                    name="serviceStatus" 
                    appendTo="body"
                    [options]="serviceStatusOptions"
                    optionLabel="label"
                    optionValue="value">
                </p-dropdown>
            </div>
            <div class="form-control">
                <label for="serviceStartDate">{{ 'SERVICE-START' | translate }}</label>
                <p-calendar
                    dateFormat="dd/mm/yy"
                    formControlName="serviceStartDate"
                    name="serviceStartDate"
                    [monthNavigator]="true"
                    [yearNavigator]="true"
                    appendTo="body"
                    [yearRange]="'2000:2055'"
                    [showIcon]="true"
                    i18n>
                </p-calendar>
            </div>
            <div class="form-control">
                <label for="serviceEndDate">{{ 'SERVICE-END' | translate }}</label>
                <p-calendar
                    dateFormat="dd/mm/yy"
                    formControlName="serviceEndDate"
                    name="serviceEndDate"
                    [monthNavigator]="true"
                    [yearNavigator]="true"
                    appendTo="body"
                    [yearRange]="'2000:2055'"
                    [showIcon]="true"
                    i18n>
                </p-calendar>
            </div>
            <div class="buttons">
                <div class="form-button">
                    <button (click)="clearFilters()" class="easymarine black" type="button">{{ 'CLEAR' | translate }}</button>
                </div>
                <div class="form-button">
                    <button class="easymarine primary" type="button" (click)="searchData()" [disabled]="loading">{{ 'FIND' | translate }}</button>
                </div>
            </div>
        </div>
    </form>
    
    <div class="divider"></div>
    
    <div class="total-container">
        <div class="total-value">
            <span class="total-label">Total Geral:</span>
            <span class="total-amount">{{ totalValue | currency:'BRL':'symbol':'1.2-2':'pt' }}</span>
        </div>
    </div>
    
    <div class="table">
        <p-table 
            #tt 
            [value]="filteredReportData" 
            [autoLayout]="true" 
            [loading]="loading"
            [paginator]="true"
            [rows]="pageSize"
            [totalRecords]="totalElements"
            [lazy]="true"
            (onLazyLoad)="onLazyLoad($event)"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
            [rowsPerPageOptions]="[10, 20, 50, 100]">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{ 'TITLE-NUMBER' | translate }}</th>
                    <th>{{ 'CUSTOMER' | translate }}</th>
                    <!-- <th>{{ 'BENEFICIARY' | translate }}</th> -->
                    <th>{{ 'ORIGIN-TYPE' | translate }}</th>
                    <th>{{ 'SERVICE' | translate }}</th>
                    <th>{{ 'SERVICE-OBSERVATION' | translate }}</th>
                    <th>{{ 'BOX-REF' | translate }}</th>
                    <th>{{ 'SERVICE-STATUS' | translate }}</th>
                    <th>{{ 'CONTRACT-START' | translate }}</th>
                    <th>{{ 'CONTRACT-END' | translate }}</th>
                    <th>{{ 'TOTAL-VALUE' | translate }}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>{{ item.titleNumber }}</td>
                    <td>{{ item.customerName }}</td>
                    <td>
                        <div class="origin-cell">
                            <fa-icon *ngIf="item.originType === 'BOAT'" [icon]="['fas', 'anchor']" class="origin-icon"></fa-icon>
                            <i *ngIf="item.originType === 'CUSTOMER'" class="pi pi-user"></i>
                            <span *ngIf="item.originType === 'BOAT'">{{ item.boatName }}</span>
                            <span *ngIf="item.originType === 'CUSTOMER'">{{ 'CUSTOMER' | translate }}</span>
                        </div>
                    </td>
                    <td>{{ item.serviceName }}</td>
                    <td class="text-center">
                        <i *ngIf="item.observation" class="pi pi-exclamation-circle" 
                           pTooltip="{{ item.observation }}" tooltipPosition="top"></i>
                    </td>
                    <td>{{ item.boxRef | slice:0:12 }}</td>
                    <td class="text-center">
                        <button 
                            type="button"
                            class="status-button"
                            [ngClass]="{
                                'status-active': item.serviceStatus === 'Ativo',
                                'status-inactive': item.serviceStatus === 'Inativo'
                            }"
                            [pTooltip]="item.serviceStatus === 'Ativo' ? 'Serviço Ativo' : 'Serviço Inativo'"
                            tooltipPosition="top">
                            {{ item.serviceStatus }}
                        </button>
                    </td>
                    <td class="text-center">{{ item.contractStartDate ? (item.contractStartDate | date:'dd/MM/yyyy') : '--' }}</td>
                    <td class="text-center">{{ item.contractEndDate ? (item.contractEndDate | date:'dd/MM/yyyy') : '--' }}</td>
                    <td class="text-right">{{ item.totalValue | currency:'BRL':'symbol':'1.2-2':'pt' }}</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="10" class="text-center">
                        <div class="empty-message-container">
                            Não foram encontrados resultados
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-fieldset>
